import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";
import { commonFields } from "./helpers/commonFields";

const ObilazniceModel: IModel = {
  title: "Obilaznice",
  apiPath: "obilaznice",
  httpUpdateVerb: "put",
  forms: {
    "default": {
      fields: ["id", "hps_id", "tip_id", "naziv", "naziv_en", "hps_drustvo", "info_url"]
    },
  },
  listViews: {
    "default": {
      fields: ["id", "hps_id", "tip_id", "naziv", "hps_drustvo", "info_url"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "naziv",
      source: "naziv",
      ttoken: "common.naziv",
      type: "text",
      filter: true,
      validation: {
        required: true
      },
    },
    {
      title: "naziv EN",
      source: "naziv_en",
      ttoken: "common.naziv_en",
      type: "text",
      filter: true,
      validation: {
        required: true
      },
    },
    {
      title: "hps_id",
      source: "hps_id",
      ttoken: "obilaznice.hps_id",
      type: "wholenum",
      filter: true
    },
    {
      title: "tip_id",
      source: "tip_id",
      ttoken: "obilaznice.tip_id",
      type: "picker",
      items: {
        labels: ["common.obilaznica_tockasta", "common.obilazinica-vezna"],
        values: [15, 25]
      },
      filter: true,
      validation: {
        required: true
      },
      translate: true
    },
    {
      title: "HPS Drustvo",
      source: "hps_drustvo",
      ttoken: "obilaznice.hps_drustvo",
      type: "text",
      filter: true
    },
    {
      title: "Info URL",
      source: "info_url",
      ttoken: "obilaznice.info_url",
      type: "url",
      width: "full",
      filter: true
    },
    {
      title: "points",
      source: "points",
      ttoken: "obilaznice.points",
      type: "array"
    },
   coreFields.modified_on,
   coreFields.created_on,  
   commonFields.wkt,
   commonFields.proj,
   {
    title: "Active",
    source: "active",
    ttoken: "obilaznice.active",
    type: "boolean"
   }
  ]
}

export default ObilazniceModel;
